import React from "react";
import styles from "./style.module.css";
import { NavLink } from "react-router-dom";

const NotFound = () => {
  return (
    <div>
      <div className={styles.center}>
        <div className={styles.error}>
          <div className={styles.number}>4</div>
          <div className={styles.illustration}>
            <div className={styles.circle}></div>
            <div className={styles.clip}>
              <div className={styles.paper}>
                <div className={styles.face}>
                  <div className={styles.eyes}>
                    <div className={styles.eye_left}></div>
                    <div className={styles.eye_right}></div>
                  </div>
                  <div className={styles.rosyCheeks_left}></div>
                  <div className={styles.rosyCheeks_right}></div>
                  <div className={styles.mouth}></div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.number}>4</div>
        </div>

        <div className={styles.text}>
          صفحه‌ای که به دنبالش هستید وجود ندارد.
        </div>
        <NavLink to={"/"} className={styles.button}>
          بازگشت به خانه
        </NavLink>
      </div>
    </div>
  );
};

export default NotFound;
